import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { client } from "../../../utils/apolloClient";
import { environmentURLs } from "../../../components/common/CaptureEnvironment";

const initialState = {
    isUnsubscribeLocationsPending: true,
    isUnsubscribeLocationsFulfilled: false,
    connectionIdsToBeDisabled: [],
    fetchSolutionConnectionsPending: true,
    isDisableSolutionConnectionPending: true,
    fetchSolutionConnectionsFulfilled: false,
    isDisableSolutionConnectionFulfilled: false
};

export const unsubscribeLocations = createAsyncThunk(
    'unsubscribeLocations',
    async ({ solutionId, entityIdList, token,isBulkSubscribed,buyerName, buyerEmail, subscriptions, solutionData }) => {
        let response = await client.authorizeRequest({
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/bulk/unsubscribe`,
            data: {
                solutionId,
                entityIdList,
                consentType: 'subscription',
                isBulkSubscribed,
                buyerName,
                buyerEmail,
                subscriptions,
                solutionData
            }
        })
        return {
            response
        };
    }
);

export const fetchSolutionConnections = createAsyncThunk(
    'fetchSolutionConnections',
    async ({ solutionId, entities, token }) => {
        let response = await client.authorizeRequest({
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/consents/entities`,
            data: {
                solutionId,
                entities,
                consentType: 'connection'
            }
        })
        let connectionConsents = response && response.data; 
        let connectionConsentsNotDisabled = connectionConsents.filter(consent => consent.requested_status !== "disable");
        return {
            connectionConsentsNotDisabled: connectionConsentsNotDisabled 
        };
    }
);

export const disableConnection = createAsyncThunk(
    'disableConnection',
    async ({ connectionIds, token }) => {
        let response = await client.authorizeRequest({
            method: 'POST',
            headers: {
                Authorization: `Bearer ${token}`
            },
            url: `${environmentURLs.REACT_APP_MP_DP_METADATA_URL}/subscriptions/connection/disable`,
            data: connectionIds
            
        })
        return {
            response
        };
    }
);

const removeLocationsSlice = createSlice({
        name:'removeLocationsSlice',
        initialState,
        reducers:{
            setRemoveLocationsInitialStates: state => {
                state.isUnsubscribeLocationsPending = true;
                state.isUnsubscribeLocationsFulfilled = false;
                state.fetchSolutionConnectionsPending = true;
                state.isDisableSolutionConnectionPending = true;
                state.fetchSolutionConnectionsFulfilled = false;
                state.isDisableSolutionConnectionFulfilled = false;
                state.connectionIdsToBeDisabled = [];
            }
        },
        extraReducers:{
            [unsubscribeLocations.fulfilled]: state =>{
                state.isUnsubscribeLocationsPending = false;
                state.isUnsubscribeLocationsFulfilled = true;
            },
            [unsubscribeLocations.pending]: state => {
                state.isUnsubscribeLocationsPending = true;
                state.isUnsubscribeLocationsFulfilled = false;
            },
            [unsubscribeLocations.rejected]: state => {
                state.isUnsubscribeLocationsPending = false;
                state.isUnsubscribeLocationsFulfilled = false;
            },
            [fetchSolutionConnections.fulfilled]: (state, action) => {
                let connectionConsentsNotDisabled = 
                    action.payload &&
                    action.payload.connectionConsentsNotDisabled; 
                let connectionIdsToBeDisabled = connectionConsentsNotDisabled.map(consent => consent.id);
                state.connectionIdsToBeDisabled = [...connectionIdsToBeDisabled];
                state.fetchSolutionConnectionsPending = false;
                state.fetchSolutionConnectionsFulfilled = true;
            },
            [fetchSolutionConnections.pending]: (state) => {
                state.fetchSolutionConnectionsPending = true;
            },
            [fetchSolutionConnections.rejected]: (state) => {
                state.fetchSolutionConnectionsPending = false;
            },
            [disableConnection.fulfilled]: (state) => {
                state.isDisableSolutionConnectionPending = false;
                state.isDisableSolutionConnectionFulfilled = true;
            },
            [disableConnection.pending]: (state) => {
                state.isDisableSolutionConnectionPending = true;
            },
            [disableConnection.rejected]: (state) => {
                state.isDisableSolutionConnectionPending = false;
            }
        }
})

export const {
    setRemoveLocationsInitialStates
} = removeLocationsSlice.actions;

export default removeLocationsSlice.reducer;